import * as React from 'react';

const H4ChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 20v-6h7v6h2V6h-2v6H5V6H3v14h2zM20.3 8.5V4.3h-1.6l-3 4.3v1.1h3.2V11h1.4V9.7h1.1V8.5h-1.1zm-1.4 0h-1.7L18.9 6v2.5z"
        />
    </svg>
);

H4ChunkySvg.displayName = 'H4ChunkySvg';
export default H4ChunkySvg;
